import request from '@/utils/request.js'

// 获取安全员分页列表
export const getSecurityUserPageList = (data) => {
    return request({
        url: '/cloud/securityUser/pageList',
        method: 'post',
        data: data
    })
}

// 获取安全员列表
export const getSecurityUserList = (name) => {
    return request({
        url: '/cloud/securityUser/list',
        method: 'get',
        params: {
            name: name
        }
    })
}

// 新增安全员
export const addSecurityUser = (data) => {
    return request({
        url: '/cloud/securityUser/add',
        method: 'post',
        data: data
    })
}

// 更新安全员
export const updateSecurityUser = (data) => {
    return request({
        url: '/cloud/securityUser/update',
        method: 'post',
        data: data
    })
}

// 获取安全员详情
export const getSecurityUserDetail = (id) => {
    return request({
        url: '/cloud/securityUser/info?id=' + id,
        method: 'get'
    })
}